module.exports = __webpack_public_path__ + "img/dd-dice-numbers.710f598e.svg";